import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {Modal, Button, Alert} from 'antd';
import request from 'superagent';
import Constants from '../../../commons/Constants';

class AlertConfigurationPlatformConfirm extends Component {

    state = {
        loading: false,
        visible: false,
        status: Constants.STATUS.init,
        confirmData: [],
        errorMessage:''
    }

    showModal = () => {
        this.setState({
            loading: true,
            visible: true,
            status: Constants.STATUS.init,
            confirmData: [],
            errorMessage:''
        });
        var data = {paData: this.props.paData};
        request.post('/api/dashboard/alert/configuration/platformVerify')
            .withCredentials()
            .set('Content-Type', 'application/json; charset=utf-8')
            .send(data)
            .end((error, response) => {
                if (!error && response) {
                    var confirmData = response.body.confirmData;
                    this.setState({
                        loading: false,
                        confirmData: confirmData,
                    });
                    this.setState({status: Constants.STATUS.done});
                } else {
                    this.setState({
                        loading: false,
                        confirmData: []
                    });
                    this.setState({status: Constants.STATUS.error});
                    this.setState({errorMessage: "Failed to verify configuration."});
                }
            });
    }

    handleOk = (e) => {
        this.props.handleSubmit(e);
        this.setState({loading: false, visible: false});
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    percentFormatter = (cell, row, enumObject, rowIndex) => {
        return (
            <div className="editable-cell-text-wrapper">{cell}%</div>
        );
    }
    createCustomToolBar = props => {
        return (
            <div>
                <div className='searchFiled'>
                    { props.components.searchPanel }
                </div>
            </div>
        );
    }

    render() {

        const { visible, loading, confirmData } = this.state;
        const options = {
            defaultSortName: 'hostName',
            defaultSortOrder: 'asc',
            toolBar: this.createCustomToolBar,
            noDataText: 'No platform alert found.',
            searchDelayTime: 500
        };

        return (
            <div>
                <Button onClick={this.showModal} className="btn-save ant-btn-primary" title="Save">
                    <i title="Save"></i>Save
                </Button>
                <Modal visible={visible} title='Platform Alert Confirm' onOk={this.handleOk} onCancel={this.handleCancel} maskClosable={false} width={1200}
                    footer={[
                        <Button key="submit" type="primary" size="large" loading={loading} disabled={this.state.status === Constants.STATUS.error} onClick={this.handleOk}>Save</Button>,
                        <Button key="back" size="large" onClick={this.handleCancel}>Cancel</Button>,
                    ]}>

                    <div>
                        <Alert style={{ display: this.state.status === Constants.STATUS.error ? 'block' : 'none' }}
                               message={this.state.errorMessage} type="error" showIcon/>
                    </div>

                    <div style={{margin: 20}}>
                        <BootstrapTable ref="table" data={ confirmData } search={ true } options={ options } striped hover condensed>
                            <TableHeaderColumn dataField='hostName' isKey dataSort={ true } width="30%">Host Name</TableHeaderColumn>
                            <TableHeaderColumn dataField='cpuAlarm' dataFormat={this.percentFormatter} dataSort={ true } width="10%">CPU Alarm</TableHeaderColumn>
                            <TableHeaderColumn dataField='cpuWarning' dataFormat={this.percentFormatter} dataSort={ true } width="10%">CPU Warning</TableHeaderColumn>
                            <TableHeaderColumn dataField='memoryAlarm' dataFormat={this.percentFormatter} dataSort={ true } width="10%">Memory Alarm</TableHeaderColumn>
                            <TableHeaderColumn dataField='memoryWarning' dataFormat={this.percentFormatter} dataSort={ true } width="10%">Memory Warning</TableHeaderColumn>
                            <TableHeaderColumn dataField='diskAlarm' dataFormat={this.percentFormatter} dataSort={ true } width="10%">Disk Alarm</TableHeaderColumn>
                            <TableHeaderColumn dataField='diskWarning' dataFormat={this.percentFormatter} dataSort={ true } width="10%">Disk Warning</TableHeaderColumn>
                            <TableHeaderColumn dataField='notification' dataSort={ true } width="10%">Notification</TableHeaderColumn>
                        </BootstrapTable>
                    </div>

                </Modal>
            </div>
        );
    }
}
export default AlertConfigurationPlatformConfirm;


// WEBPACK FOOTER //
// ./src/modules/dashboard/alert-configuration/AlertConfigurationPlatformConfirm.js